/* tslint:disable */

declare var Object: any;
export interface SfRequestInterface {
  "id"?: number;
}

export class SfRequest implements SfRequestInterface {
  "id": number;
  constructor(data?: SfRequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SfRequest`.
   */
  public static getModelName() {
    return "SfRequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SfRequest for dynamic purposes.
  **/
  public static factory(data: SfRequestInterface): SfRequest{
    return new SfRequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SfRequest',
      plural: 'sfRequests',
      path: 'sfRequests',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SfRequest.ts